define 'controller/DropdownController', ['jquery', 'custom/media-query'], ($, mq) ->
  class DropdownController

    constructor: (@$el) ->
      _self = @
      @$plpFilterContainer = @$el.closest("[data-controller-element=filter-list-content]")

      $(window).resize =>
        if mq.M_and_up
          @_closeAll(@$el.data("is-open") == true)

      if @$el.data("is-open") == true
        @_open()

      @$el.on 'click', '.dropdown__header', (e) =>
        if @_closeOther() && @_closeAtCurrentMQ()
          @_toggle_and_close_other()
        else
          @_toggle(@$el)

    _toggle_and_close_other: ->
      if @_isOpened()
        @_closeAll()
      else
        @_closeAll()
        @_open()

    _toggle: (element)->
      if @_isOpened()
        @_close(element)
      else
        @_open()

    _closeAll: (hasDefaultOpen) ->
      if !hasDefaultOpen
        if (@$el.data('close-elements'))
          @_close(@$el.data('close-elements'))
        else
          @_close(@$el)

    _close: (element) ->
      if $(element).hasClass("dropdown--opened")
        $(element).removeClass("dropdown--opened")
      else
        $(element).find('.dropdown').removeClass("dropdown--opened")

      $(element).find('.dropdown__content').removeClass("dropdown__content--visible")
      $(element).find('#js-dropdown__header--opened').removeAttr("id")
      $(element).find('.dropdown__icon').removeClass("dropdown__icon--opened")
      $(element).find('.dropdown__title').removeClass("dropdown__title--invisible")
      $(element).find('.dropdown__title-opened').removeClass("dropdown__title-opened--visible")

    _open: ->
      if @$plpFilterContainer.length > 0
        @$plpFilterContainer.find("#js-dropdown__header--opened").removeAttr("id")

      @$el.addClass("dropdown--opened")
      @$el.find(".dropdown__content").addClass("dropdown__content--visible")
      @$el.find(".dropdown__header").attr("id", "js-dropdown__header--opened")
      @$el.find(".dropdown__icon").addClass("dropdown__icon--opened")
      @$el.find('.dropdown__title').addClass("dropdown__title--invisible")
      @$el.find('.dropdown__title-opened').addClass("dropdown__title-opened--visible")
      @_scrollToFilterHeadline()

    _closeOther: ->
      return @$el.data('closing-behaviour') == 'close-other'

    _closeAtCurrentMQ: ->
      all = @$el.data('close-mq')== "all"
      upToM = mq.up_to_M && @$el.data('close-mq') == "up_to_M"
      mAndUp = mq.M_and_up && @$el.data('close-mq') == "M_and_up"
      return  all || upToM || mAndUp

    _isOpened: ->
      return @$el.find(".dropdown__content").hasClass("dropdown__content--visible")

    _scrollToFilterHeadline: ->
      scrollto = document.getElementById("js-dropdown__header--opened")
      if scrollto && !@_closeOther()
        document.getElementById("js-filterlist-scroll-container").scrollTop = scrollto.offsetTop

    destroy: ->
      @$el.off()